<template>
  <transition-group name="transition" tag="div" class="notifications">
    <div v-for="toast in notifications" :key="toast.id"
      @click="removeToast(toast.id)"
      class="toast"
      :style="colors(toast.type)"
    >
      <div class="toast-content">
        <font-awesome-icon v-if="toast.type === 'success'" icon="check-circle" class="f3"/>
        <font-awesome-icon v-else-if="toast.type === 'warning'" icon="exclamation-triangle" class="f3"/>
        <font-awesome-icon v-else-if="toast.type === 'error'" icon="times-circle" class="f3"/>
        <font-awesome-icon v-else-if="toast.type === 'info'" icon="exclamation-circle" class="f3"/>
        <font-awesome-icon v-else icon="exclamation-circle" class="f3"/>
        <span>{{ toast.title }}</span>
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  computed: {
    notifications () {
      return this.$store.getters['notification/items']
    }
  },
  methods: {
    removeToast (toastId) {
      this.$store.dispatch('notification/remove', toastId)
    },
    colors (toastType) {
      switch (toastType) {
        case 'success':
          return { backgroundColor: '#47d78a', color: '#fff' }
        case 'warning':
          return { backgroundColor: '#febc22', color: '#fff' }
        case 'error':
          return { backgroundColor: '#f7471c', color: '#fff' }
        case 'info':
          return { backgroundColor: '#1c85d5', color: '#fff' }
        default:
          return { backgroundColor: '#343a40', color: '#fff' }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  overflow: hidden;
  z-index: 1052;
  pointer-events: none;
}
.toast {
  align-self: flex-end;
  box-shadow: 0 3px 6px rgba(0,0,0,.15), 0 2px 4px rgba(0,0,0,.10);
  // box-shadow: 0 1px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);
  border-radius: .25rem;
  margin-top: .5rem;
  display: inline-block;
  opacity: 1;
  transition: all .5s;
  pointer-events: auto;
  cursor: pointer;
  &-content {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: .7rem;
    margin: 1rem;
    align-items: center;
  }
  z-index: 1054;
}
.transition-enter {
  opacity: 0;
  transform: translateY(10px);
}
.transition-leave-to {
  opacity: 0;
}
.transition-leave-active {
  position: absolute;
  z-index: 1053;
}
</style>
